import { render, staticRenderFns } from "./TVerticalPanel.vue?vue&type=template&id=06bdd0c5&scoped=true&"
import script from "./TVerticalPanel.vue?vue&type=script&lang=js&"
export * from "./TVerticalPanel.vue?vue&type=script&lang=js&"
import style0 from "./TVerticalPanel.vue?vue&type=style&index=0&id=06bdd0c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdd0c5",
  null
  
)

export default component.exports